import { render, staticRenderFns } from "./PostComments.vue?vue&type=template&id=00b7b52e&scoped=true&"
import script from "./PostComments.vue?vue&type=script&lang=js&"
export * from "./PostComments.vue?vue&type=script&lang=js&"
import style0 from "./PostComments.vue?vue&type=style&index=0&id=00b7b52e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b7b52e",
  null
  
)

export default component.exports